import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { ClientRequestUpdateRequest } from '../../types';
import { responseHandler } from '../utils';

type MutationParams = {
  id: string;
  data: ClientRequestUpdateRequest;
};

export const useUpdateClientRequestFirestore = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  mutationFn: ({ id, data }) => axiosInstance
    .post(`/v3-updateClientRequest?id=${id}`, data, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(responseHandler),
  ...options,
});
